import { render, staticRenderFns } from "./profile-add-child.vue?vue&type=template&id=c96ad8e8&"
import script from "./profile-add-child.vue?vue&type=script&lang=js&"
export * from "./profile-add-child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports